
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27.968 22.975"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M25.635 18.381H2.333A2.312 2.312 0 000 20.675a2.318 2.318 0 002.333 2.3h23.3a2.318 2.318 0 002.333-2.3 2.308 2.308 0 00-2.331-2.294zM25.635 9.187H2.333A2.318 2.318 0 000 11.487a2.318 2.318 0 002.333 2.3h23.3a2.318 2.318 0 002.333-2.3 2.313 2.313 0 00-2.331-2.3zM2.333 4.594h23.3a2.318 2.318 0 002.333-2.3A2.308 2.308 0 0025.635 0H2.333A2.313 2.313 0 000 2.3a2.308 2.308 0 002.333 2.294z"}})])])
          )
        }
      }
    